/**
 * Guards against sending `Authorization: Bearer undefined` (or similar)
 * when a session is missing or a refresh has failed
 */
export const isValidAccessToken = (token: unknown): token is string => {
  if (typeof token !== "string") return false;

  const trimmed = token.trim();

  return trimmed !== "" && trimmed !== "undefined" && trimmed !== "null";
};
